<template>
<div class="container">
    <form ref="contactform" id="contact-form" method="post" action="" role="form" v-on:submit.prevent="submitForm">
        <div class="controls">
            <div class="row">
                <div class="col-md-6">
                    <div class="input-group input-group-sm mb-3">
                        <div class="input-group-prepend">
                            <div class="input-group-text">
                                <input type="radio" v-on:click="isnoLodger" value="false" v-model="alreadyLodger" checked aria-label="Ich bin kein Mieter">
                            </div>
                        </div>
                        <input type="text" class="form-control" disabled value="Ich bin kein Mieter">
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="input-group input-group-sm mb-3">
                        <div class="input-group-prepend">
                            <div class="input-group-text">
                                <input type="radio" v-on:click="isLodger" value="true" v-model="alreadyLodger" aria-label="Ich bin Mieter">
                            </div>
                        </div>
                        <input type="text" class="form-control" disabled value="Ich bin Mieter">
                    </div>
                </div>
            </div>
        </div>
        <div class="messages"></div>
        <transition name="component-fade" mode="out-in">
            <div>
                <div class="controls text-left d-block" ref="isnoLodger">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="input-group input-group-sm mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroup-sizing-sm" style="min-width: 8rem;">Vorname</span>
                                </div>
                                <input v-model="forename" id="form_name" type="text" name="name" class="form-control" placeholder="Bitte geben Sie ihren Vornamen ein" required="required" data-error="Ihr Vorname wird benötigt.">
                            </div>
                            <div class="help-block with-errors"></div>
                        </div>
                        <div class="col-md-6">
                            <div class="input-group input-group-sm mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroup-sizing-sm" style="min-width: 8rem;">Nachname</span>
                                </div>
                                <input v-model="lastname" id="form_lastname" type="text" name="surname" class="form-control" placeholder="Bitte geben Sie ihren Nachnamen ein" required="required" data-error="Nicht Ihren Nachnamen vergessen.">
                            </div>
                            <div class="help-block with-errors"></div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="input-group input-group-sm mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroup-sizing-sm" style="min-width: 8rem;">Email</span>
                                </div>
                                <input v-model="email" id="form_email" type="email" name="email" class="form-control" placeholder="Bitte geben Sie hier Ihre E-Mail ein" required="required" data-error="Emailadresse wird benötigt.">
                            </div>
                            <div class="help-block with-errors"></div>
                        </div>
                        <div class="col-md-6">
                            <div class="input-group input-group-sm mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroup-sizing-sm" style="min-width: 8rem;">Thema</span>
                                </div>
                                <select v-model="thema" id="form_need" name="need" class="custom-select" required="required" data-error="Bitte hier Ihren Grund angeben">
                                    <option value="Wohnungssuche">Wohnungssuche</option>
                                    <option value="Mängel">Mängelmeldung</option>
                                    <option value="Sonstiges">Sonstiger Grund</option>
                                    <option value="Datenschutz">Datenschutz</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-group input-group-sm mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" style="min-width: 8rem;">Ihre Nachricht</span>
                                </div>
                                <textarea v-model="message" id="form_message" name="message" class="form-control" placeholder="Ihre Nachricht an uns" rows="4" required="required" data-error="Bitte hinterlassen Sie eine Nachricht."></textarea>
                            </div>
                            <div class="help-block with-errors"></div>
                        </div>
                    </div>
                    <div class="row text-right">
                        <div class="col-md-12 mb-3">
                            <button type="submit" class="btn btn-success btn-send btn-sm">Nachricht senden</button>
                        </div>
                    </div>
                </div>
                <div class="controls text-left d-none" ref="isLodger">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="input-group input-group-sm mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroup-sizing-sm" style="min-width: 8rem;">Vorname</span>
                                </div>
                                <input v-model="forename" id="form_name" type="text" name="name" class="form-control" placeholder="Bitte geben Sie ihren Vornamen ein" required="required" data-error="Ihr Vorname wird benötigt.">
                            </div>
                            <div class="help-block with-errors"></div>
                        </div>
                        <div class="col-md-6">
                            <div class="input-group input-group-sm mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroup-sizing-sm" style="min-width: 8rem;">Nachname</span>
                                </div>
                                <input v-model="lastname" id="form_lastname" type="text" name="surname" class="form-control" placeholder="Bitte geben Sie ihren Nachnamen ein" required="required" data-error="Nicht Ihren Nachnamen vergessen.">
                            </div>
                            <div class="help-block with-errors"></div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="input-group input-group-sm mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroup-sizing-sm" style="min-width: 8rem;">Email</span>
                                </div>
                                <input v-model="email" id="form_email" type="email" name="email" class="form-control" placeholder="Bitte geben Sie hier Ihre E-Mail ein" required="required" data-error="Emailadresse wird benötigt.">
                            </div>
                            <div class="help-block with-errors"></div>
                        </div>
                        <div class="col-md-6">
                            <div class="input-group input-group-sm mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroup-sizing-sm" style="min-width: 8rem;">Thema</span>
                                </div>
                                <select v-model="thema" id="form_need" name="need" class="custom-select" required="required" data-error="Bitte hier Ihren Grund angeben">
                                    <option value="Wohnungssuche">Wohnungssuche</option>
                                    <option value="Mängel">Mängelmeldung</option>
                                    <option value="Sonstiges">Sonstiger Grund</option>
                                    <option value="Datenschutz">Datenschutz</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row text-left">
                        <div class="col-md-6">
                            <div class="input-group input-group-sm mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroup-sizing-sm" style="min-width: 8rem;">Mietobjekt</span>
                                </div>
                                <v-select v-model="selObject" ref="sel_city" id="sel_city" name="sel_city" @search="onSearchObject" required="required" :options="objects" class="form-control small"></v-select>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="input-group input-group-sm mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroup-sizing-sm" style="min-width: 8rem;">Wohnung</span>
                                </div>
                                <input v-model="wohnung" ref="wohnung" id="form_wohnung" type="text" name="wohnung" class="form-control" placeholder="Bitte geben Sie hier Ihre Wohnung ein" data-error="Wohnung wird benötigt.">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-group input-group-sm mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" style="min-width: 8rem;">Ihre Nachricht</span>
                                </div>
                                <textarea v-model="message" id="form_message" name="message" class="form-control" placeholder="Ihre Nachricht an uns" rows="4" required="required" data-error="Bitte hinterlassen Sie eine Nachricht."></textarea>
                            </div>
                            <div class="help-block with-errors"></div>
                        </div>
                    </div>
                    <div class="row text-right">
                        <div class="col-md-12 mb-3">
                            <button type="submit" class="btn btn-success btn-send btn-sm">Nachricht senden</button>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </form>
    <div ref="contactmessage" class="alert alert-success" style="display: none;margin-top: 10px;">Ihre Nachricht wurde übertragen.</div>
    <div ref="contacterror" class="alert alert-danger" style="display: none;margin-top: 10px;">Es ist ein Fehler aufgetreten.</div>
</div>
</template>

<script>
import axios from "axios";

export default {
    mounted() {
        this.$ga.page('contact')
        this.$ga.screenview('contact')
    },
    data() {
        return {
            forename: '',
            lastname: '',
            email: '',
            thema: '',
            message: '',
            alreadyLodger: false,
            objects: [],
            wohnung: '',
            rooms: [],
            selObject: ''
        }
    },
    methods: {
        onSearchObject(search, loading) {
            // eslint-disable-next-line
            //console.log(typeof (search))
            if (search.length > 4) {
                loading(true)
                this.searchObject(search, loading, this.objects)
            } else {
                // eslint-disable-next-line
                //console.log('zu wenig buchstaben')
            }
        },
        // eslint-disable-next-line
        searchObject(search, loading, data) {
            let currentObj = this
            fetch(
                `autocomplete.php?type=object&query=${escape(search)}`, {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': "*",
                    'Sec-Fetch-Mode': 'no-cors'
                }
            ).then(res => {
                res.json().then(
                    json => {
                        // eslint-disable-next-line
                        //console.log('json', json)
                        // eslint-disable-next-line
                        //console.log('json', 'success', json.success)
                        // eslint-disable-next-line
                        //console.log('json', 'items', json.results)
                        currentObj.objects = json.results
                    }
                );
                loading(false);
            });
        },
        isnoLodger() {
            if (this.$refs.isLodger.classList.contains('d-block')) {
                this.$refs.isLodger.classList.remove('d-block')
                this.$refs.isLodger.classList.add('d-none')
                this.$refs.isnoLodger.classList.remove('d-none')
                this.$refs.isnoLodger.classList.add('d-block')
                this.$refs.wohnung.required = false
                this.$refs.sel_city.required = false
            }
        },
        isLodger() {
            if (this.$refs.isnoLodger.classList.contains('d-block')) {
                this.$refs.isnoLodger.classList.remove('d-block')
                this.$refs.isnoLodger.classList.add('d-none')
                this.$refs.isLodger.classList.remove('d-none')
                this.$refs.isLodger.classList.add('d-block')
                this.$refs.wohnung.required = true
                this.$refs.sel_city.required = true
            }
        },
        // getAutoObject(search, loading) {
        // this.$refs.object.typeahead({
        //     source: function (query, result) {
        //         $.ajax({
        //             url: "autocomplete.php",
        //             data: 'type=object&query=' + query,
        //             dataType: "json",
        //             type: "POST",
        //             success: function (data) {
        //                 result($.map(data, function (item) {
        //                     return item;
        //                 }));
        //             }
        //         });
        //     }
        // });
        // },
        getAutoRoom() {
            var currentObj = this
            const instance = axios.create({
                baseURL: 'https://www.hanse-domizil.de'
            });
            instance.post('/autocomplete.php', {
                method: 'post',
                url: '/autocomplete.php',
                data: {
                    query: currentObj.forename,
                    id_object: currentObj.lastname,
                    type: 'room'
                }
            }).then(function () {})

            // this.$refs.object.typeahead({
            //     source: function (query, result) {
            //         currentObj = this;
            //         $.ajax({
            //             url: "autocomplete.php",
            //             data: 'type=room&id_object=' + currentObj.$refs.object.getValue() + '&query=' + query,
            //             dataType: "json",
            //             type: "POST",
            //             success: function (data) {
            //                 result($.map(data, function (item) {
            //                     return item;
            //                 }));
            //             }
            //         });
            //     }
            // });
        },
        submitForm() {
            let currentObj = this;
            const instance = axios.create({
                baseURL: 'https://www.hanse-domizil.de'
            });
            //console.dir(currentObj)
            // Alter defaults after instance has been created
            instance.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
            instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
            if (currentObj.alreadyLodger) {
                instance.post('/contact.php', {
                    method: 'post',
                    url: '/contact.php',
                    data: {
                        forename: currentObj.forename,
                        lastname: currentObj.lastname,
                        thema: currentObj.thema,
                        email: currentObj.email,
                        message: currentObj.message,
                        alreadyLodger: currentObj.alreadyLodger,
                        mietobjekt: (currentObj.alreadyLodger ? currentObj.selObject.label : ''),
                        wohnung: (currentObj.alreadyLodger ? currentObj.wohnung : '')
                    }
                }).then(function () {
                    currentObj.$ga.event({
                        eventCategory: 'contact',
                        eventAction: 'send',
                        eventLabel: 'thema',
                        eventValue: currentObj.thema
                    })
                    currentObj.$refs.contactform.style.display = 'none'
                    currentObj.$refs.contactmessage.style.display = 'block'
                }, function () {
                    //console.dir(currentObj)
                    currentObj.$ga.event({
                        eventCategory: 'contact',
                        eventAction: 'error',
                        eventLabel: 'object_data',
                        eventValue: currentObj.forename + ' ' + currentObj.lastname + ', thema: ' + currentObj.thema + ', message: ' + currentObj.message + ', objekt: "' + (currentObj.alreadyLodger ? currentObj.selObject.label + ', ' + currentObj.wohnung + '"' : '')
                    })
                    currentObj.$refs.contacterror.style.display = 'block'
                    //this.errorMessage = 'Form submission failed.';
                });
            } else {
                instance.post('/contact.php', {
                    method: 'post',
                    url: '/contact.php',
                    data: {
                        forename: currentObj.forename,
                        lastname: currentObj.lastname,
                        thema: currentObj.thema,
                        email: currentObj.email,
                        message: currentObj.message
                    }
                }).then(function () {
                    currentObj.$ga.event({
                        eventCategory: 'contact',
                        eventAction: 'send',
                        eventLabel: 'thema',
                        eventValue: currentObj.thema
                    })
                    currentObj.$refs.contactform.style.display = 'none'
                    currentObj.$refs.contactmessage.style.display = 'block'
                }, function () {
                    //console.dir(currentObj)
                    currentObj.$ga.event({
                        eventCategory: 'contact',
                        eventAction: 'error',
                        eventLabel: 'object_data',
                        eventValue: currentObj.forename + ' ' + currentObj.lastname + ', thema: ' + currentObj.thema + ', message: ' + currentObj.message
                    })
                    currentObj.$refs.contacterror.style.display = 'block'
                    //this.errorMessage = 'Form submission failed.';
                });
            }
        }
    }
}
</script>

<style>
.vs__dropdown-toggle {
    border: 0px !important;
}

.vs__selected-options {
    padding: 0px !important;
}

.vs__selected {
    border: 0px !important;
}

.vs__search {
    margin: 0px !important;
    padding: 0px !important;
}

.vs__actions {
    padding: 0px !important;
}
</style>
